import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {Modal} from "antd";
import {InputField} from "~/components/Forms";
import {roleApi} from "~/api";
import {apiError, handleRequest} from "~/utils";

/**
 * Modal thêm chức vụ mới. Gọi onAdded({key, name}) khi thành công.
 */
function PermissionFormAdd({open, onCancel, onAdded}) {

	const {control, handleSubmit, reset, formState: {isSubmitting, errors}} = useForm({
		defaultValues: {name: ''},
		resolver: yupResolver(Yup.object().shape({
			name: Yup.string().required('Bạn chưa nhập tên chức vụ'),
		})),
	});

	const onSubmit = async (data) => {
		const [error, response] = await handleRequest(roleApi.add(data));
		if (!apiError('Thêm chức vụ thất bại', error, response)) {
			reset({name: ''});
			onAdded(response.data);
		}
	};

	const handleCancel = () => {
		reset({name: ''});
		onCancel();
	};

	return (
		<Modal
			title="Thêm chức vụ"
			open={open}
			onCancel={handleCancel}
			onOk={handleSubmit(onSubmit)}
			confirmLoading={isSubmitting}
			okText="Thêm"
			cancelText="Hủy"
		>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Controller
					control={control}
					name="name"
					render={({field}) => (
						<InputField label="Tên chức vụ" errors={errors} {...field} />
					)}
				/>
			</form>
		</Modal>
	);
}

export default PermissionFormAdd;
